import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, any>;

export const TextCell: React.FC<Props> = ({ formattedValue }) => {
  return <span>{formattedValue}</span>;
};
